import {
  AccountService,
  IAccountServiceOptions,
  ISaveServiceOptions,
  SaveService,
  StoreIdCookieInformationService,
  ZipCodeCookieInformationService
} from '@inter-ikea-kompis/services';
import { DexfSettingsFilterSegmentEnum } from '@inter-ikea-kompis/enums';
import { getDexfApiKey } from '@inter-ikea-storageone/range';
import { IStorageOneDexfSettings } from 'contexts/serviceSettings';
import { getRange, stripURLOfQueryParameters } from 'utils/queryUtils';
import { getLocale } from 'i18n/i18nUtils';

export const createSaveService = (
  dexfSettings: IStorageOneDexfSettings,
  dexfSettingsFilterSegment: DexfSettingsFilterSegmentEnum
) => {
  const range = getRange();
  const dexfApiKey = getDexfApiKey(range);
  const applicationName = `storageone${range}.${dexfSettingsFilterSegment}`;
  const dexfApplicationId = `storageone${range}`;

  //As of now we need to send in what segment we want to use in oAuth in DEXF Settings in the applicationName prop
  const saveServiceOptions: ISaveServiceOptions = {
    applicationName: applicationName,
    dexfApplicationId: dexfApplicationId,
    settings: dexfSettings,
    dexfApiKey
  };
  return new SaveService(saveServiceOptions);
};

export const createAccountService = (
  dexfSettings: IStorageOneDexfSettings,
  dexfSettingsFilterSegment: DexfSettingsFilterSegmentEnum
) => {
  const range = getRange();
  const locale = getLocale();
  const applicationName = `storageone${range}.${dexfSettingsFilterSegment}`;

  //As of now we need to send in what segment we want to use in oAuth in DEXF Settings in the applicationName prop
  const accountServiceSettings: IAccountServiceOptions = {
    applicationName: applicationName,
    redirectUri: stripURLOfQueryParameters(['state', 'code']),
    logoutRedirectUri: stripURLOfQueryParameters(['state', 'code']),
    settings: dexfSettings,
    locale
  };
  return new AccountService(accountServiceSettings);
};

export const createZipCodeService = (dexfSettings: IStorageOneDexfSettings) => {
  return new ZipCodeCookieInformationService({ settings: dexfSettings });
};

export const createStoreIdCookieInformationService = (dexfSettings: IStorageOneDexfSettings) => {
  return new StoreIdCookieInformationService({ settings: dexfSettings });
};
